import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=45e65c9c&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e65c9c",
  null
  
)

export default component.exports